import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class DeptBranchJobService {
  
  constructor(private http: HttpClient) { }

  getDepartments() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/get_departments', OPTIONS);
  }

  createUpdateDepartment(departmentForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/create_update_department', departmentForm, OPTIONS);
  }

  getBranches() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/get_branches', OPTIONS);
  }

  createUpdateBranch(branchForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/create_update_branch', branchForm, OPTIONS);
  }

  getJobs() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/get_jobs', OPTIONS);
  }

  createUpdateJob(branchForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/create_update_job', branchForm, OPTIONS);
  }

  getDepartmentList() {
    return this.http.get<any>(Library.API_ENDPOINT + 'definition/get_department_list', OPTIONS);
  }

  deleteDepBranchJob(form: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'definition/delete_department_branch_job', form, OPTIONS);
  }
}
